import { getServerFormattedDate } from './getFormattedDate';

const getPaddedDatePart = (datePartString, length) => {
    const paddingChars = [];

    for(let i = 0; i < length; i++) {
        paddingChars.push('0');
    }

    const paddedDatePartString = paddingChars.join('') + datePartString;

    return paddedDatePartString.substring(paddedDatePartString.length - length);
}

const toDateTime = (dateString, twoDigitYear = false) => {
    const dateObj = new Date(dateString);

    return toDate(dateString, twoDigitYear) + ' ' + 
        getPaddedDatePart(dateObj.getHours(), 2) + ':' + 
        getPaddedDatePart(dateObj.getMinutes(), 2);
}

const toDate = (dateString, twoDigitYear = false) => {
    if(dateString === null || dateString === undefined) return null;

    // Must be a UTC formatted date in order to be properly formatted
    // There is a fallback for date/times that don't have the timezone
    // If a timezone is not specified, creating a new Date object may or may not take into account the user's local timezone into account
    // If this is the case, sometimes dates are not formatted correctly
    if(dateString.indexOf('T') !== -1) {
        const dateObj = new Date(dateString);

        let year = getPaddedDatePart(dateObj.getFullYear(), 4);

        if(year.length > 0 && twoDigitYear === true) {
            year = year.substring(2);
        }

        return getPaddedDatePart(dateObj.getMonth() + 1, 2) + '/' + 
            getPaddedDatePart(dateObj.getDate(), 2) + '/' + 
            year;
    }
    return getServerFormattedDate(dateString);
};

const toNumber = (numberString, numberOfDecimals) => {
    if(numberString === null || numberString === undefined) return null;

    return (+numberString).toFixed(numberOfDecimals);
};

const toMoney = (numberString) => {
    return `$${toNumber(numberString, 2)}`;
};

const toPercent = (numberString, precision) => {
    return ((+numberString) * 100).toFixed(precision) +  "%";
}

export default {
    toDateTime, 
    toDate, 
    toNumber, 
    toMoney, 
    toPercent
};